module.exports = __webpack_public_path__ + "f1054f18213d880d0b1a97d788e41bbf.svg";